"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var state_1 = require("../state");

var Select_styles_1 = require("./Select.styles");

var Option = function (_a) {
  var children = _a.children,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      value = _a.value,
      className = _a.className;

  var _c = react_1.useContext(state_1.SelectContext),
      onChange = _c.onChange,
      setIsExpanded = _c.setIsExpanded,
      menuId = _c.menuId,
      registerOption = _c.registerOption,
      selectedValue = _c.selectedValue;

  var isSelected = selectedValue === value;
  var classNames = classnames_1.default({
    'is-selected': isSelected,
    'is-disabled': disabled
  }, className);
  react_1.useEffect(function () {
    registerOption(value);
  }, [value, registerOption]);
  return react_1.useMemo(function () {
    var handleOnClick = function (event) {
      if (!disabled) {
        var newEvent = __assign({}, event);

        newEvent.target.value = value;
        onChange(newEvent);
        setIsExpanded(false);
      }
    };

    return react_1.default.createElement(Select_styles_1.OptionWrapper, {
      role: "option",
      onClick: handleOnClick,
      className: classNames,
      "aria-selected": isSelected,
      id: menuId + "_" + value
    }, children, " ", isSelected && react_1.default.createElement(Select_styles_1.Checkmark, null));
  }, [children, disabled, value, isSelected, className, menuId]);
};

exports.default = Option;